export { default } from './ArcadeToken'
